import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginDataService } from "app/login/login-data.service";
import { Globals } from 'app/services/globals';

@Injectable()
export class IsUserLoggedGuard implements CanActivate {

	constructor(private _login: LoginDataService, private _route: Router, private globals: Globals) {
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		if (!this._login.islogged) {
			this._route.navigate(['/login'])
			return false
		}
		//The pages were an admin can have access
		const adminAccess = ["home", "user-list", "edit-user", "add-user","my-profile", "kiosks-list", "kiosk-payments", "kiosk-reports", "add-kiosk","edit-kiosk", "modules_settings"];
		//The pages were a client can have access
		const clientAccess = ["home","content-text", "edit-content-text", "news-list", "add-news","edit-news-intranet","visiting-departments",
			"add-visiting-department","edit-visiting-department","edit-department-field",
			"newsletter-list","add-newsletter", "edit-newsletter", "newsletter-subscribers", "add-subscriber", "edit-slider","add-slider","slider-list","edit-footer","add-footer","footer-list",
			"add-welcome","edit-welcome","welcome-list", "my-profile", "faq", "add-client-faq","edit-client-faq","kiosks-list", "kiosk-payments", "kiosk-reports", "add-useful-contacts","edit-useful-contacts", "edit-kiosk",
		    "departments-list","add-edit-appointment-department", "appointments-officers-list", 
			"add-edit-appointments-officers", "appointments-list", "add-edit-appointments"];
		// The pages where an Appointment Officer can have access
		const officerAccess =["home","my-profile", "appointments-list", "add-edit-appointments"]

		const roleId = (this.globals.userProfile)?this.globals.userProfile.role.rid:  parseInt(localStorage.getItem("_roleId"));
		const selectedClientEncr  = localStorage.getItem("_sc");
		let isClientSelected = false;
		if(selectedClientEncr !== null && selectedClientEncr !== "null"){ //if I logged in as an admin/BPO and select a client from DashBoard
			isClientSelected = true
		}

		const nextRoute = next.url[0].path;
		if( nextRoute != '' &&
			(([1,3,4].indexOf(roleId) > -1 && adminAccess.indexOf(nextRoute) >-1) || //daca e admin || BPO si acceseaza o pagina coresp
			(roleId == 2 && clientAccess.indexOf(nextRoute)> -1) ||
			([1,3,4].indexOf(roleId) > -1 && isClientSelected && clientAccess.indexOf(nextRoute) >-1) || //daca e admin, are selectat un user si acceseaza paginile clientului
			(roleId == 5 && officerAccess.indexOf(nextRoute) > -1) // Daca e Appointment Officer  si acceseaza o pagina la care are dreptul
			)
			){
			return true;
		}
		return false
	}

}
